import { ContentsHeader } from 'app-template-lib/components/layout-panel';
import { IRoute } from 'app-template-lib/utils';
import { TContentsContentParams, TContentsHeaderParams } from '../shared/t-contents-params';
import TermsOfServicePage from './components/termsOfService/tos.container';
import AboutPage from './components/about/about.container';
import ColumnLayout from './components/column-layout';

/**
 * React Router の Route Itemws
 * @param T ヘッダーのパラメーターの型
 * @param U コンテンツのパラメーターの型
 */
export const routeItems: IRoute<TContentsHeaderParams, TContentsContentParams>[] = [
    {
        id: 'ef8f17ca-0101-466b-b266-04808ec33622',
        title: 'デモレイアウト',
        pathname: '/',
        path: '/',
        isBack: false,
        mainContents: [
            {
                id: 'dda7db6a-b7c2-4e6f-b3a0-eef8af507acc',
                tabTitle: '',
                header: {
                    title: 'Mainタイトル',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: ColumnLayout },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
    {
        id: 'ef8f17ca-0101-466b-b266-04808ec33611',
        title: '利用規約',
        pathname: '/termsofservice/',
        path: '/termsofservice/:lgcode/',
        isBack: false,
        mainContents: [
            {
                id: 'dda7db6a-b7c2-4e6f-b3a0-eef8af507a11',
                tabTitle: '',
                header: {
                    title: '利用規約',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: TermsOfServicePage },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
    {
        id: 'ef8f17ca-0101-466b-b266-04808ec336332',
        title: '利用規約',
        pathname: '/about',
        path: '/about/:lgcode/',
        isBack: false,
        mainContents: [
            {
                id: 'dda7db6a-b7c2-4e6f-b3a0-eef8af507dj5',
                tabTitle: '',
                header: {
                    title: '本サイトについて',
                    isSave: true,
                    params: null,
                    element: ContentsHeader,
                },
                content: { params: null, element: AboutPage },
            },
        ],
        topContents: [],
        bottomContents: [],
        leftContents: [],
        rightContents: [],
    },
];
